// extracted by mini-css-extract-plugin
module.exports = {"section":"YoutubeSection_section__Y9SpF","title":"YoutubeSection_title__RMxZQ","embedContainer":"YoutubeSection_embedContainer__aH2r_"};